<template>
  <div>
    <div @click.shift.exact="selectItem">
      <v-card class="mx-auto my-5 py-5 px-2 p-sortingItem_card mr-2 ml-2">
        <v-btn
          v-ripple
          class="p-sortingItem__groupSelect mb-3"
          outlined
          color="caret"
          @click.stop="() => selectItem()"
        >
          {{ !combined ? 'グループ選択' : 'ここまで選択' }}
        </v-btn>
        <span class="p-sortingItem__handle">
          <slot></slot>
        </span>
      </v-card>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SortingItemLayout',
  props: {
    index: {
      type: Number,
      required: true
    },
    combined: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    selectItem () {
      this.$emit('select-item')
    }
  }
}
</script>

<style scoped>
.p-sortingItem__groupSelect {
  z-index: 10;
}
</style>
